import { useEffect, useState } from "react";
import Button from "../components/Button";
import styles from "./AddMenuNotesModal.module.css";
import { validateForm } from "../helpers/helperFunctions";

function AddMenuNotesModal({ eventData, setEventData, bd, getServers }) {
  const [isOpen, setIsOpen] = useState(false);
  const [menuNotes, setMenuNotes] = useState("");
  const [banDetails, setBanDetails] = useState({});

  useEffect(() => {
    //setMenuNotes(bd.menuItemNotes);
    banDetails.Price = Number(banDetails.Price).toFixed(2);
  }, []);

  const openModal = () => {
    setBanDetails(bd);
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setMenuNotes("");
    setIsOpen((x) => !x);
  };

  const updateNotes = (e) => {
    e.preventDefault();
    if (banDetails.menuLocation == "OFI") {
      updateOtherFoodNotes(e);
    } else {
      updateMenuNotes(e);
    }
  };

  const updateOtherFoodNotes = async (e) => {
    console.log(bd);
    //e.preventDefault();
    if (validateForm(e.target)) {
      const formData = new URLSearchParams({
        id: bd.itemId,
        banId: eventData.idBanquetHeader,
        mNotes: banDetails.menuItemNotes ? banDetails.menuItemNotes : "",
        qty: banDetails.qty,
        price: banDetails.Price,
        gratPercent: eventData.percentGrat,
        userId: JSON.parse(localStorage.getItem("userLogin")).userId,
      });
      await fetch("/api/detail/addotherfood", {
        method: "put",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          setEventData({
            ...eventData,
            serviceTotal: data.priceUpdate.serviceTotal,
            fbTotal: data.priceUpdate.fbTotal,
            barTotal: data.priceUpdate.barTotal,
            details: data.details,
          });
          getServers();
        });
      closeModal();
    }
  };

  const updateMenuNotes = async (e) => {
    // e.preventDefault();
    console.log(bd);
    if (validateForm(e.target)) {
      const formData = new URLSearchParams({
        id: bd.itemId,
        banId: eventData.idBanquetHeader,
        mNotes: banDetails.menuItemNotes ? banDetails.menuItemNotes : "",
        qty: banDetails.qty,
        price: banDetails.Price,
        addOnPrice: !banDetails.addOnPrice ? 0 : banDetails.addOnPrice,
        gratPercent: eventData.percentGrat,
        isPricePer: banDetails.isPricePer,
        banAttendance: eventData.BanAttendance,
      });
      await fetch("/api/detail/menuitem", {
        method: "put",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          setEventData({
            ...eventData,
            serviceTotal: data.priceUpdate.serviceTotal,
            fbTotal: data.priceUpdate.fbTotal,
            barTotal: data.priceUpdate.barTotal,
            details: data.details,
          });
          getServers();
        });
      closeModal();
    }
  };

  return (
    <>
      <Button onClick={openModal} type="tOutline">
        {/* <i className={`fa-solid fa-plus ${styles.plus}`}></i> */}
        Edit
      </Button>

      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content ${styles.modalTop} modal-narrow ${styles.textLeft}`}>
            <h3 className="modal-header">Add/Edit Menu Notes</h3>
            <form className={styles.formMenuItem} action="" onSubmit={updateNotes} noValidate>
              <input type="hidden" name="category" value={bd.menuLocation} />
              <div className={styles.formSection}>
                <h4 className={styles.menuHeader}>Menu Item: {banDetails.itemDesc}</h4>
              </div>
              <div className={styles.formSection}>
                <label htmlFor="qty">Qty:</label>
                <input
                  type="number"
                  name="qty"
                  id="qty"
                  onFocus={(e) => e.target.select()}
                  value={banDetails.qty}
                  onChange={(e) => setBanDetails({ ...bd, qty: Number(e.target.value) })}
                />
              </div>
              <div className={styles.formSection}>
                <div>
                  <label htmlFor="price">Price:</label>
                  <input
                    type="number"
                    name="price"
                    id="price"
                    onFocus={(e) => e.target.select()}
                    value={Number(banDetails.Price)}
                    onChange={(e) => {
                      setBanDetails({ ...bd, Price: Number(e.target.value) });
                    }}
                  />
                </div>
                {bd.menuLocation != "OFI" && (
                  <div>
                    <label htmlFor="price">Addon Price:</label>
                    <input
                      type="number"
                      name="addonPrice"
                      id="addonPrice"
                      onFocus={(e) => e.target.select()}
                      value={Number(banDetails.addOnPrice)}
                      onChange={(e) => {
                        setBanDetails({ ...bd, addOnPrice: Number(e.target.value) });
                      }}
                    />
                  </div>
                )}
              </div>
              <div className={styles.formSection}>
                <textarea className={styles.menuNotes} onChange={(e) => setBanDetails({ ...bd, menuItemNotes: e.target.value })}>
                  {bd.menuItemNotes}
                </textarea>
              </div>
              <div className={styles.formSelectButtons}>
                <Button type="primary">Save</Button>
                <Button type="save" onClick={closeModal}>
                  Close
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default AddMenuNotesModal;
